import { bulkEditProbeSupplierEmptyA } from './itemsBulkEditProbeFixtureData';
import { suppliers } from './itemsFixtureData';

/**
 * DL-66423 epic (dl-58563 — "Bulk edit Supplier / Brand / Brand contact on items with no value
 * set"). Deterministic rows for the *save-path* stories, isolable via `?search=NoValueProbe` (a
 * unique token, absent from every other fixture name so it never collides with the existing
 * `?search=BulkEditProbe` set the field-enablement specs use — keeping their baselines untouched).
 *
 * Every row spreads `bulkEditProbeSupplierEmptyA` (supplier = null) and overrides only what the
 * story needs, so the shape stays identical to the seeded items:
 * - `noValueProbeBrandA/B`   — brand = null (+ contact null, since brand contact needs a brand):
 *   the "Brand on items with no value set" save path (754686). There is no `BrandShouldNotUpdateRule`,
 *   so Brand is editable regardless; these keep the case faithful to "no value set".
 * - `noValueProbeContactA/B` — companyContactPerson = null, brand kept: the "Brand contact on items
 *   with no value set" save path (754688).
 * - `noValueProbeSupNoBrand` — supplier set, brand = null: the epic's recorded divergence between
 *   `SupplierShouldNotUpdateRule` (backend, gates on supplier *and* brand) and
 *   `useBulkEditBrandSupplier` (frontend, gates on supplier alone). Makes the case observable.
 * - `noValueProbeScale01..12`— supplier = null, at scale: the 10+-items Supplier save path (754692).
 */

// 90600-90619 — a range confirmed unused by every other fixture file (the 90230-90253 range
// used here originally collides with bulkUpdateProbeFixtureData.ts's own probe rows).
let seq = 90600;
const nextId = () => seq++;

export const noValueProbeBrandA = {
  ...bulkEditProbeSupplierEmptyA,
  id: nextId(),
  name: 'NoValueProbe Brand A',
  userDefinedId: 'IT-90600',
  brand: null,
  companyContactPerson: null,
};

export const noValueProbeBrandB = {
  ...noValueProbeBrandA,
  id: nextId(),
  name: 'NoValueProbe Brand B',
  userDefinedId: 'IT-90601',
};

export const noValueProbeContactA = {
  ...bulkEditProbeSupplierEmptyA,
  id: nextId(),
  name: 'NoValueProbe Contact A',
  userDefinedId: 'IT-90602',
  companyContactPerson: null,
};

export const noValueProbeContactB = {
  ...noValueProbeContactA,
  id: nextId(),
  name: 'NoValueProbe Contact B',
  userDefinedId: 'IT-90603',
};

export const noValueProbeSupNoBrand = {
  ...bulkEditProbeSupplierEmptyA,
  id: nextId(),
  name: 'NoValueProbe SupNoBrand',
  userDefinedId: 'IT-90604',
  supplier: suppliers[0],
  brand: null,
  companyContactPerson: null,
};

export const noValueProbeScaleRows = Array.from({ length: 12 }, (_, i) => {
  const id = nextId();
  return {
    ...bulkEditProbeSupplierEmptyA,
    id,
    name: `NoValueProbe Scale ${String(i + 1).padStart(2, '0')}`,
    userDefinedId: `IT-${id}`,
  };
});

export const noValueProbeRows = [
  noValueProbeBrandA,
  noValueProbeBrandB,
  noValueProbeContactA,
  noValueProbeContactB,
  noValueProbeSupNoBrand,
  ...noValueProbeScaleRows,
];
